export default "__VITE_ASSET__4wlV$G57__"